$(document).on('ready turbolinks:load', function () {
  $('[data-toggle="tooltip"]').tooltip();
  window.parent.attachChecklistEvent();
});

function attachChecklistEvent(){
  var isMasterCheckboxChecked = $('.master-checkbox input').is(':checked');

  if (isMasterCheckboxChecked == true) {
    $('.sub-checkbox input[type="checkbox"]').prop('disabled', true);
  }

  $('.master-checkbox input').change(function() {
    if ($(this).is(':checked')) {
      $('.sub-checkbox input[type="checkbox"]').prop('disabled', true);
    } else {
      $('.sub-checkbox input[type="checkbox"]').prop('disabled', false);
    }
  });

  $('.check-list-item').change(function() {
    var checkboxValue = $(this).is(':checked');
    var check_list_id = $(this).data("check-list-id");
    $.ajax({
      dataType: 'script',
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/update_user_check_list?check_list_id=${check_list_id}&value=${checkboxValue}`,
      type: 'GET'
    });
  });

  $('.appraisal-textbox').on('change', function() {
    var value = $(this).val();
    var type = $(this).data("value-type");
    var check_list_id = $(this).data("check-list-id");
    console.log('Textbox updated value', value);
    console.log('Textbox updated type', type);
    $.ajax({
      dataType: 'script',
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/update_user_appraisal_check_list?check_list_id=${check_list_id}&value=${value}&type=${type}`,
      type: 'GET'
    });
  });

  $('.previous-year-input').on('change', function() {
    var value = $(this).val();
    var check_list_id = $(this).data("check-list-id");
    $.ajax({
      dataType: 'script',
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/update_previous_year_value?check_list_id=${check_list_id}&value=${value}`,
      type: 'GET'
    });
  });
}

window.attachChecklistEvent = attachChecklistEvent;
